var _path, _g, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33397_21993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 40,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.05362H40V27.611H0V2.05362Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33397_21993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1681 27.6098C39.0982 27.6098 39.0316 27.6032 38.9651 27.5832L25.8336 24.2654L12.7022 27.5832C12.5591 27.6198 12.4093 27.6165 12.2696 27.5765L0.602329 24.2055C0.246256 24.1023 0 23.7729 0 23.3968V3.17389C0 2.91099 0.123129 2.66141 0.329451 2.50167C0.539102 2.34527 0.81198 2.29202 1.06156 2.36523L12.5158 5.67305L20.5753 3.85491C21.0146 3.73511 20.787 4.3668 20.8968 4.81938C21.01 5.27195 20.7051 5.55991 20.2592 5.67305L12.7022 7.36357C12.5591 7.40018 12.4093 7.39685 12.2696 7.35691L1.66722 4.29535V22.7612L12.5158 25.8927L25.6306 22.5749C25.7637 22.5416 25.9035 22.5416 26.0333 22.5749L38.3328 25.6897V7.20716L30.863 5.46235C30.4171 5.34921 30.1069 4.62565 30.22 4.1764C30.3265 3.72049 30.4137 3.41694 30.863 3.53342L39.3677 5.72963C39.7404 5.82613 40 6.16224 40 6.54826V26.7712C40 27.0275 39.8835 27.2737 39.6805 27.4368C39.5308 27.5499 39.3478 27.6098 39.1681 27.6098Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7202 14.1455C25.6065 14.1455 25.4949 14.1127 25.3986 14.0403C25.1887 13.8825 20.2538 10.2042 20.2538 5.52406C20.2538 2.42664 22.6534 0 25.7202 0C28.7848 0 31.1844 2.42664 31.1844 5.52406C31.1844 10.2042 26.2517 13.8869 26.0396 14.0403C25.9455 14.1127 25.8318 14.1455 25.7202 14.1455ZM25.7202 1.66969C23.2681 1.66969 21.7 3.04919 21.7 5.52406C21.7 8.99413 24.6593 11.7719 25.7202 12.6466C26.7789 11.7676 29.8 8.99413 29.8 5.52406C29.8 3.04919 28.1701 1.66969 25.7202 1.66969Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7204 8.35874C24.3003 8.35874 23.1472 7.2055 23.1472 5.78809C23.1472 4.36814 24.3003 3.2149 25.7204 3.2149C27.1406 3.2149 28.291 4.36814 28.291 5.78809C28.291 7.2055 27.138 8.35874 25.7204 8.35874ZM25.7204 4.50023C25.0116 4.50023 24.4338 5.07939 24.4338 5.78809C24.4338 6.4968 25.0116 7.07341 25.7204 7.07341C26.4292 7.07341 27.0044 6.4968 27.0044 5.78809C27.0044 5.07939 26.4266 4.50023 25.7204 4.50023Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4992 26.7733C12.0399 26.7733 11.6672 26.3939 11.6672 25.9281V7.39228C11.6672 6.92639 12.0399 6.55035 12.4992 6.55035C12.9584 6.55035 13.3311 6.92639 13.3311 7.39228V25.9281C13.3311 26.3939 12.9584 26.7733 12.4992 26.7733Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8336 24.0665C25.3743 24.0665 24.9983 23.7951 24.9983 23.4642V15.0242C24.9983 14.6932 25.3743 14.4218 25.8336 14.4218C26.2928 14.4218 26.6655 14.6932 26.6655 15.0242V23.4642C26.6655 23.7951 26.2928 24.0665 25.8336 24.0665Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMap);
export default __webpack_public_path__ + "static/media/ic_map.c23e9de63c0e68bda2fc2d903b5918ce.svg";
export { ForwardRef as ReactComponent };